import styled from 'styled-components';

export const LongSteelOrders3ModalContent = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & span {
    display: block;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

export const LongSteelOrders3Img = styled.img`
  width: 100%;
`;
